import React, { useState } from 'react';
import DownloadButton from './DownloadButton';
import type { AuditFilters } from '../../../../../types/auditLogs';

interface AuditFiltersProps {
  filters: AuditFilters;
  onFiltersChange: (filters: AuditFilters) => void;
}

const AuditFiltersComponent: React.FC<AuditFiltersProps> = ({ filters, onFiltersChange }) => {
  const [fromDate, setFromDate] = useState<string>('');
  const [toDate, setToDate] = useState<string>('');

  const handleFromDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setFromDate(value);
    onFiltersChange({
      ...filters,
      fromDate: value ? new Date(value) : undefined
    });
  };

  const handleToDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setToDate(value);
    onFiltersChange({
      ...filters,
      toDate: value ? new Date(value) : undefined
    });
  };

  return (
    <div className="audit-filters">
      <div className="date-range-section">
        <div className="date-input-group">
          <label htmlFor="from-date">From:</label>
          <input
            id="from-date"
            type="date"
            value={fromDate}
            onChange={handleFromDateChange}
            className="date-input"
          />
        </div>
        <div className="date-input-group">
          <label htmlFor="to-date">To:</label>
          <input
            id="to-date"
            type="date"
            value={toDate}
            onChange={handleToDateChange}
            className="date-input"
            min={fromDate || undefined}
          />
        </div>
        <DownloadButton />
      </div>
    </div>
  );
};

export default AuditFiltersComponent;